const ResponsiveGamingIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      version="1"
      viewBox="0 0 36 36"
      fill="white"
    >
      <defs>
        <clipPath id="77f952853d">
          <path d="M4 6.363h22V28H4zm0 0"></path>
        </clipPath>
        <clipPath>
          <path d="M21 13h9.988v15.984H21zm0 0"></path>
        </clipPath>
      </defs>
      <g clipPath="url(#77f952853d)">
        <path
          fillRule="evenodd"
          d="M25.484 8.11h-.886v-.442a.458.458 0 00-.453-.461H5.504a.455.455 0 00-.453.461v11.71c0 .255.203.462.453.462H15.71v3.61H13.75l-.668 2.71h2.629v.902h-4.887a.444.444 0 01-.441-.453c0-.238.195-.449.445-.449h1.152a.234.234 0 00.22-.176l.624-2.535h-7.32a1.35 1.35 0 01-1.344-1.347V7.652a1.34 1.34 0 011.344-1.347h18.64c.739 0 1.34.61 1.34 1.347zm-10.66 14.437a.895.895 0 00.887-.902.897.897 0 00-.887-.903.898.898 0 00-.89.903c0 .5.398.902.89.902zm0 0"
        ></path>
      </g>
      <path
        fillRule="evenodd"
        d="M29.04 12.621h-.888v-1.805H17.488v14.442h3.555v2.707h-3.105a1.343 1.343 0 01-1.336-1.36V10.371c0-.754.59-1.36 1.335-1.36h9.766c.738 0 1.336.602 1.336 1.36zm0 0"
      ></path>
      <g clipPath="url(#7e73173132)">
        <path
          fillRule="evenodd"
          d="M23.27 13.523h6.21c.739 0 1.336.602 1.336 1.36v12.625c0 .75-.593 1.36-1.336 1.36h-6.21a1.34 1.34 0 01-1.336-1.36V14.883c0-.754.59-1.36 1.336-1.36zm-.45 11.735h7.11v-9.93h-7.11zm3.555 2.707a.897.897 0 00.887-.902c0-.5-.399-.903-.887-.903a.895.895 0 00-.89.902c0 .497.398.903.89.903zm0 0"
        ></path>
      </g>
    </svg>
  );
};

export default ResponsiveGamingIcon;
